





























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiIbs } from "@/store/modules/SupervisiIbsStore";
import SupervisiIbsSvc from "@/services/SupervisiIbsService";
import { JENIS_SUPERVISI_OPTS, kategoriKepatuhanColor } from "@/types/SupervisiIbs";

@Component({})
export default class SupervisiIbsListPage extends Vue {
  filter = {
    tanggal_dari: "",
    tanggal_sampai: "",
    jenis_supervisi: null as string | null,
  };

  jenisOpts = JENIS_SUPERVISI_OPTS;

  pagination = {
    page: 1,
    itemsPerPage: 15,
  };

  headers = [
    { text: "Nomor Formulir", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_supervisi" },
    { text: "Supervisor", value: "supervisor", sortable: false },
    { text: "Skor", value: "skor", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, align: "end" },
  ];

  get items() {
    return storeSupervisiIbs.items;
  }

  get loading() {
    return storeSupervisiIbs.loading;
  }

  get meta() {
    return storeSupervisiIbs.meta;
  }

  mounted() {
    this.fetch();
  }

  @Watch("pagination", { deep: true })
  onPagination() {
    this.fetch();
  }

  kepatuhanColor(kat: string | null) {
    return kategoriKepatuhanColor(kat);
  }

  fetch() {
    const params: any = {
      page: this.pagination.page,
      per_page: this.pagination.itemsPerPage,
    };
    if (this.filter.tanggal_dari) params.tanggal_dari = this.filter.tanggal_dari;
    if (this.filter.tanggal_sampai) params.tanggal_sampai = this.filter.tanggal_sampai;
    if (this.filter.jenis_supervisi) params.jenis_supervisi = this.filter.jenis_supervisi;
    storeSupervisiIbs.fetchList(params);
  }

  applyFilter() {
    this.pagination.page = 1;
    this.fetch();
  }

  resetFilter() {
    this.filter = { tanggal_dari: "", tanggal_sampai: "", jenis_supervisi: null };
    this.applyFilter();
  }

  createNew() {
    this.$router.push({ name: "supervisi-ibs-form", params: { id: "baru" } });
  }

  openEdit(id: number) {
    this.$router.push({ name: "supervisi-ibs-form", params: { id: String(id) } });
  }

  printPdf(id: number) {
    SupervisiIbsSvc.printPdf(id);
  }

  formatDate(d: string) {
    if (!d) return "-";
    const [y, m, day] = d.split("-");
    return `${day}-${m}-${y}`;
  }
}
